<template>
  <div class="connector-label" :style="styleConnectorLabel">
    <div
      v-for="(labelValue, index) in labels"
      :key="'label-' + index + '-' + componentKey"
      class="label"
      :style="labelValue.styles"
      tabindex="0"
      :class="{ animation: showAnimation }"
    >
      {{ labelValue.label }}
    </div>
    <div
      v-for="(connector, index) in connectors"
      :key="'connector-' + index + '-' + componentKey"
      class="connector"
      :style="connector.styles"
      :class="{ animation: showAnimation }"
    ></div>
  </div>
</template>

<script>
import { computed, getCurrentInstance, toRefs } from '@vue/composition-api';

export default {
  name: 'ConnectorLabel',
  props: {
    currentStep: {
      type: Object,
      default: () => ({}),
    },
    stepsForStyle: {
      type: [String, Number],
    },
    zoomOutEffect: {
      type: Boolean,
      default: false,
    },
    showAnimation: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { root }) {
    const componentKey = getCurrentInstance().vnode.key;
    const { currentStep, stepsForStyle, zoomOutEffect } = toRefs(props);

    const completedLabels = computed(() => {
      return currentStep.value.label.filter((z) => z.completed);
    });

    const labels = computed(() => {
      if (!Object.keys(currentStep.value).length) return;
      if (!currentStep.value.label) return;

      return completedLabels.value.map((label) => {
        return {
          ...label.text,
          styles: {
            top: `${label.text.top}px`,
            left: `${label.text.left}px`,
            width: `${label.text.width}px`,
            zIndex: 2,
            opacity: 1 - 0.15 * stepsForStyle.value,
          },
        };
      });
    });

    const connectors = computed(() => {
      if (!Object.keys(currentStep.value).length) return;
      if (!currentStep.value.label) return;

      return completedLabels.value.map((label) => {
        return {
          ...label.connector,
          styles: {
            backgroundImage: `url(${root.getImageById(label.connector.id)})`,
            top: `${label.connector.top}px`,
            left: `${label.connector.left}px`,
            width: `${label.connector.width}px`,
            height: `${label.connector.height}px`,
            opacity: 1 - 0.15 * stepsForStyle.value,
          },
        };
      });
    });

    const styleConnectorLabel = computed(() => ({
      transform: zoomOutEffect.value
        ? `scale(${1 + 0.01 * stepsForStyle.value}) translateY(-${
            stepsForStyle.value * 5
          }px)`
        : 'scale(1) translateY(0)',
      opacity: 1 - 0.15 * stepsForStyle.value,
    }));

    return { labels, connectors, componentKey, styleConnectorLabel };
  },
};
</script>

<style lang="stylus" scoped>
color-white = colors.white

.connector-label
  transition transform 0.5s ease
  position absolute
  z-index 5

.label
  position absolute
  background-color color-white
  border-radius 20px
  height 83px
  font-size 42px
  line-height 57px
  text-align center
  padding 13px 0
  transition opacity 0.5s ease

.connector
  position absolute
  transition opacity 0.5s ease

.animation
  animation fadeIn 1.1s

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
